/**
 * Theme analytics — sends Product Clicked events to PostHog.
 *
 * Listens to `pointerdown` (capture phase) on document so the capture
 * fires BEFORE an anchor click commits navigation. Without this, a click
 * on a product card would unload the page before the in-flight POST to
 * PostHog completes — which is the same race condition that prevents
 * Shopify's standard `clicked` web-pixel event from reliably tracking
 * product card clicks.
 *
 * Product context is read from `data-product-*` attributes on the
 * `[data-product-card]` wrapper rendered by `snippets/card-product.liquid`.
 */
(function () {
  if (typeof window === 'undefined') return;

  function findProductLink(target) {
    if (!target || !target.closest) return null;
    var link = target.closest('a[href]');
    if (!link) return null;
    var href = link.getAttribute('href') || '';
    return href.indexOf('/products/') !== -1 ? link : null;
  }

  function findProductCard(target) {
    return target && target.closest ? target.closest('[data-product-card]') : null;
  }

  function getPositionInList(card) {
    var parent = card.parentElement;
    if (!parent) return null;
    var siblings = parent.querySelectorAll(':scope > [data-product-card]');
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] === card) return i + 1;
    }
    return null;
  }

  function getList() {
    try {
      var path = window.location.pathname || '';
      var collectionMatch = path.match(/^\/collections\/([^\/]+)/);
      if (collectionMatch) return 'collection:' + collectionMatch[1];
      if (path.indexOf('/search') === 0) return 'search';
      if (path.indexOf('/products/') === 0) return 'pdp-related';
      if (path === '/' || path === '') return 'home';
      return path;
    } catch (e) {
      return null;
    }
  }

  function toNumber(value) {
    if (value == null || value === '') return null;
    var cleaned = String(value).replace(/[^0-9.\-]/g, '');
    var n = parseFloat(cleaned);
    return isNaN(n) ? null : n;
  }

  function captureProductClick(event) {
    if (typeof window.posthog === 'undefined' || !window.posthog.capture) return;

    var link = findProductLink(event.target);
    if (!link) return;

    var card = findProductCard(event.target);
    if (!card) return;

    window.posthog.capture('product_clicked', {
      product_id: card.dataset.productId || null,
      product_handle: card.dataset.productHandle || null,
      product_title: card.dataset.productTitle || null,
      product_price: toNumber(card.dataset.productPrice),
      product_vendor: card.dataset.productVendor || null,
      product_type: card.dataset.productType || null,
      product_variant_id: card.dataset.productVariantId || null,
      product_url: link.getAttribute('href'),
      list: getList(),
      position: getPositionInList(card),
    });
  }

  document.addEventListener('pointerdown', captureProductClick, { capture: true });
})();
